import { SolaceServer } from 'redux/reducers/smConfigReducer';

export class DataProvider {
  public readonly solaceServers: readonly SolaceServer[] = [];

  constructor(servers: readonly SolaceServer[]) {
    this.solaceServers = servers;
  }
}
